import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  // {
  //   name: "",
  //   type: "span",
  //   class: "ui-dform-span set_des",
  //   property: "",
  //   "default_value": "<span class='dynamic-desc'><a class='reference'>Attention</a>: For Embed Button option only</span>"
  // },
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpFirepushOptInsEmbedButton Atom Module
 */
export class GpFirepushOptInsEmbedButton extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'FirePush - Opt-ins Embed Button';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'firepush-opt-ins-embed-button';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
